export const contentStyles = {
  heading: { mt: 14, mb: 6 },
  link: { fontSize: "inherit" },
  paragraph: { lineHeight: "base", fontSize: "md", mb: 4, _last: { mb: 0 }, mt: 4, color: "greyscale.600" },
  horizontalRule: { borderColor: "greyscale.400", my: { base: 6, lg: 8 } },
};
